// import components
import { styled, Autocomplete, Popper } from '@mui/material';

// import types
import type { StyledDutyLineAutocompleteProps } from './DutyLineOptionEditCell.types';

export const StyledDutyLineAutocomplete = styled(
  Autocomplete as React.ComponentType<StyledDutyLineAutocompleteProps>
)<StyledDutyLineAutocompleteProps>(() => ({
  '& .MuiAutocomplete-paper ': {
    width: ' 100%'
  },

  '& .MuiFormControl-root': {
    display: 'flex',
    justifyContent: 'center'
  }
}));

export const StyledCustomPopperEditCell = styled(Popper)(() => ({
  '.MuiAutocomplete-paper': { width: '100%', minWidth: '320px' }
}));

export const StyledShowMoreOption = styled('li')(({ theme }) => ({
  justifyContent: 'center',
  color: theme.palette.primary.main,
  cursor: 'pointer'
}));
